import type { SVGProps } from 'react';

export default function LaptopAndPhone(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.2499 7.25V6.75C19.2499 5.64543 18.3545 4.75 17.2499 4.75H7.74991C6.64534 4.75 5.74991 5.64543 5.74991 6.75V15.25M5.74991 15.25H5.53491C5.1207 15.25 4.78491 15.5858 4.78491 16C4.78491 17.2426 5.79227 18.25 7.03491 18.25H10.25M5.74991 15.25H10.25M16 17H16.01M14.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V11.75C19.25 10.6454 18.3546 9.75 17.25 9.75H14.75C13.6454 9.75 12.75 10.6454 12.75 11.75V17.25C12.75 18.3546 13.6454 19.25 14.75 19.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
